module.exports = __webpack_public_path__ + "static/header-winner-9fff590ed93fd4ef7d0228619b149c80.svg";